import { forwardRef, useState, useEffect } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import Button from 'components/Button'
import ArrowRightSpecialsIcon from 'public/icons/arrow-right-specials.svg'
import ArrowLeftIcon from 'public/icons/arrow-left.svg'
import TickIcon from 'public/icons/tick.svg'

import SailingYachtIcon from 'public/icons/sailing-yacht.svg'
import MotorYachtIcon from 'public/icons/motor-yacht.svg'
import MultihullIcon from 'public/icons/multihull.svg'
import TickInCircleIcon from 'public/icons/tick-in-circle.svg'
import { Box, Flex } from 'reflexbox'
import Input from 'components/Input'
import Checkbox from 'components/Checkbox'
import { submitCalculatorForm } from 'helpers/middleware'

import style from './CalculatorBlock.style'

const CalculatorBlockStyled = styled.div(props => ({ ...style(props) }))

const theme = {
    breakpoints: ['360px', '728px', '1024px', '1280px', '1600px']
}

// const validateEmail = input => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(input)

const CalculatorBlock = forwardRef(
    (
        {
            title1,
            title2,
            title3,
            title4,
            title5,
            title6,
            titleTag: TitleTag,
            subtitle3,
            subtitle4,
            subtitle5,
            subtitle6,
            text,
            buttonText,
            buttonLink,
            buttonIcon,
            data,
            offsetFunc,
            t
        },
        ref
    ) => {
        const hull = [
            { code: '800000001', label: t('configure-page:sailing-yacht'), icon: <SailingYachtIcon /> },
            { code: '800000000', label: t('configure-page:motor-yacht'), icon: <MotorYachtIcon /> },
            { code: '800000002', label: t('configure-page:multihull'), icon: <MultihullIcon /> }
        ]

        const material = [
            { code: 'grp', label: t('configure-page:GRP-composite') },
            { code: 'steel', label: t('configure-page:steel') },
            { code: 'wood', label: t('configure-page:wood') },
            { code: 'aluminium', label: t('configure-page:aluminium') }
        ]

        const [form, setForm] = useState({
            material: material[0].code,
            hull: hull[0].code,

            model: '',
            year: '',
            loa: '',
            beam: '',
            draft: '',

            antifouling: false,
            polishingSideAndStern: false,
            polishingSuperstructure: false,

            firstName: '',
            lastName: '',
            email: '',
            marketing: false,
            newsletter: false
        })

        const [errors, setErrors] = useState({
            material: false,
            hull: false,

            model: false,
            year: false,
            loa: false,
            beam: false,
            draft: false,

            antifouling: false,
            polishingSideAndStern: false,
            polishingSuperstructure: false,

            firstName: false,
            lastName: false,
            email: false,
            marketing: false,
            newsletter: false
        })

        const setFormValue = (key, value) => {
            setForm(state => ({
                ...state,
                [key]: value
            }))
            setErrors(state => ({
                ...state,
                [key]: false
            }))
        }

        console.log(form)

        const formErrorsStep2 = {
            model: !form.model,
            year: !form.year,
            loa: !form.loa,
            beam: !form.beam,
            draft: !form.draft
        }

        const formErrorsStep4 = {
            firstName: !form.firstName,
            lastName: !form.lastName,
            email: !form.email,
            marketing: !form.marketing
        }

        const [step, setStep] = useState(1)

        const [disabledStep2, setDisabledStep2] = useState(true)
        const [disabledStep4, setDisabledStep4] = useState(true)

        useEffect(() => {
            if (!Object.values(formErrorsStep2).some(Boolean)) {
                setDisabledStep2(false)
            } else {
                setDisabledStep2(true)
            }
        }, [formErrorsStep2])

        useEffect(() => {
            if (!Object.values(formErrorsStep4).some(Boolean)) {
                setDisabledStep4(false)
            } else {
                setDisabledStep4(true)
            }
        }, [formErrorsStep4])

        // const [submitted, setSubmitted] = useState(false)

        const handleContinue = currentStep => {
            const nextStep = currentStep + 1
            const notGrpStep = currentStep + 3
            setStep(nextStep)

            if (form.material === 'steel' || form.material === 'wood' || form.material === 'aluminium') {
                setStep(notGrpStep)
            }
        }

        const handleBack = currentStep => {
            const previousStep = currentStep - 1
            const notGrpStep = currentStep - 3
            setStep(previousStep)

            if (form.material === 'steel' || form.material === 'wood' || form.material === 'aluminium') {
                setStep(notGrpStep)
            }
        }

        const handleSubmit = () => {
            const lastStep = 5
            setStep(lastStep)
            console.log(form, 'submitted form')
            submitCalculatorForm(form)
        }

        return (
            <CalculatorBlockStyled step={step} ref={ref}>
                <div className="CalculatorWrapper">
                    <div className="progressBar">
                        <div />
                        <div />
                        <div />
                    </div>

                    <div className="CalculatorContainer">
                        {step === 1 && (
                            <div className="step-1">
                                {title1 && (
                                    <div className="Heading">
                                        {title1 && (
                                            <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title1 }} />
                                        )}
                                    </div>
                                )}

                                <div className="boatTypeContainer">
                                    {hull.map(item => (
                                        // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                        <label
                                            key={item.code}
                                            className={`radio-image${item.code === form.hull ? ' checked' : ''}`}>
                                            <input
                                                type="radio"
                                                checked={item.code === form.hull}
                                                onChange={() => setFormValue('hull', item.code)}
                                            />
                                            <div className="boatType">
                                                <div className="icon">{item.icon}</div>

                                                <p className="content">{item.label}</p>
                                            </div>
                                        </label>
                                    ))}
                                </div>

                                {title2 && (
                                    <div className="Heading">
                                        {title2 && (
                                            <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title2 }} />
                                        )}
                                    </div>
                                )}

                                {material.map(item => (
                                    // eslint-disable-next-line jsx-a11y/label-has-associated-control
                                    <label
                                        key={item.code}
                                        className={`radio${item.code === form.material ? ' checked' : ''}`}>
                                        <input
                                            type="radio"
                                            checked={item.code === form.material}
                                            onChange={() => setFormValue('material', item.code)}
                                        />
                                        {item.label}
                                    </label>
                                ))}

                                <div className="CtaContainer">
                                    <div className="CtaContainerInner">
                                        <Button
                                            variation="secondary rounded step-button-1"
                                            onClick={() => {
                                                handleContinue(1)
                                            }}>
                                            {buttonText}
                                            {buttonIcon && <ArrowRightSpecialsIcon />}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step === 2 && (
                            <div className="step-2">
                                {(title3 || subtitle3) && (
                                    <div className="Heading">
                                        {title3 && (
                                            <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title3 }} />
                                        )}
                                        {subtitle3 && <p className="Subtitle">{subtitle3}</p>}
                                    </div>
                                )}

                                <div className="CalculatorForm">
                                    <div className="col-1">
                                        <Flex
                                            theme={theme}
                                            justifyContent="space-between"
                                            flexDirection={['column', 'column', 'row', 'row']}>
                                            <Box
                                                mb={['20px', '20px', '30px', '30px']}
                                                theme={theme}
                                                width={['100%', '100%', '65.5%', '65.5%']}>
                                                <Input
                                                    id="model"
                                                    type="text"
                                                    name="model"
                                                    label={t('configure-page:model-of-yacht')}
                                                    className={errors.model ? 'has-error' : null}
                                                    value={form.model}
                                                    onChange={e => setFormValue('model', e.target.value)}
                                                />
                                            </Box>

                                            <Box
                                                mb={['20px', '20px', '30px', '30px']}
                                                theme={theme}
                                                width={['100%', '100%', '31%', '31%']}>
                                                <Input
                                                    id="year"
                                                    type="number"
                                                    name="year"
                                                    label={t('configure-page:year-of-construction')}
                                                    className={errors.year ? 'has-error' : null}
                                                    onChange={e => setFormValue('year', e.target.value)}
                                                    value={form.year}
                                                />
                                            </Box>
                                        </Flex>

                                        <Flex theme={theme} mb="30px" justifyContent="space-between">
                                            <Box theme={theme} mb="30px" width="31%">
                                                <Input
                                                    id="loa"
                                                    type="number"
                                                    name="loa"
                                                    label={t('configure-page:loa-m')}
                                                    className={errors.loa ? 'has-error' : null}
                                                    onChange={e => setFormValue('loa', e.target.value)}
                                                    value={form.loa}
                                                />
                                            </Box>

                                            <Box theme={theme} mb="30px" width="31%">
                                                <Input
                                                    id="beam"
                                                    type="number"
                                                    name="beam"
                                                    label={t('configure-page:beam-m')}
                                                    className={errors.beam ? 'has-error' : null}
                                                    onChange={e => setFormValue('beam', e.target.value)}
                                                    value={form.beam}
                                                />
                                            </Box>

                                            <Box theme={theme} mb="30px" width="31%">
                                                <Input
                                                    id="draft"
                                                    type="number"
                                                    name="draft"
                                                    label={t('configure-page:draft-m')}
                                                    className={errors.draft ? 'has-error' : null}
                                                    onChange={e => setFormValue('draft', e.target.value)}
                                                    value={form.draft}
                                                />
                                            </Box>
                                        </Flex>

                                        <small>{t('configure-page:to-separate-decimals')}</small>
                                    </div>
                                    <div className="col-2">
                                        <Box theme={theme} mb="30px">
                                            <div className="CtaContainer">
                                                <div className="CtaContainerInner">
                                                    <Button
                                                        onClick={() => {
                                                            handleBack(2)
                                                        }}
                                                        variation="primary rounded">
                                                        {buttonIcon && <ArrowLeftIcon />}
                                                        {t('configure-page:back')}
                                                    </Button>
                                                    <Button
                                                        variation="secondary rounded"
                                                        disabled={disabledStep2}
                                                        onClick={() => {
                                                            handleContinue(2)
                                                        }}>
                                                        {t('configure-page:continue')}
                                                        {buttonIcon && <ArrowRightSpecialsIcon />}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step === 3 && (
                            <div className="step-3">
                                {(title4 || subtitle4) && (
                                    <div className="Heading">
                                        {title4 && (
                                            <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title4 }} />
                                        )}
                                        {subtitle4 && <p className="Subtitle">{subtitle4}</p>}
                                    </div>
                                )}

                                <div className="col-2">
                                    <div className="SelectYourServices">
                                        <Box theme={theme} mb="20px">
                                            <div className="checkbox-wrapper">
                                                <Checkbox
                                                    id="antifouling"
                                                    label={t('configure-page:select-your-services-option-1')}
                                                    name="antifouling"
                                                    onChange={e => setFormValue('antifouling', e.target.checked)}
                                                />
                                            </div>
                                        </Box>

                                        <Box theme={theme} mb="20px">
                                            <div className="checkbox-wrapper">
                                                <Checkbox
                                                    id="polishingSideAndStern"
                                                    label={t('configure-page:select-your-services-option-2')}
                                                    name="polishingSideAndStern"
                                                    onChange={e =>
                                                        setFormValue('polishingSideAndStern', e.target.checked)
                                                    }
                                                />
                                            </div>
                                        </Box>

                                        <Box theme={theme} mb="20px">
                                            <div className="checkbox-wrapper">
                                                <Checkbox
                                                    id="polishingSuperstructure"
                                                    label={t('configure-page:select-your-services-option-3')}
                                                    name="polishingSuperstructure"
                                                    onChange={e =>
                                                        setFormValue('polishingSuperstructure', e.target.checked)
                                                    }
                                                />
                                            </div>
                                        </Box>
                                    </div>

                                    <Box theme={theme} mb="1.25rem">
                                        <div className="CtaContainer">
                                            <div className="CtaContainerInner">
                                                <Button
                                                    onClick={() => {
                                                        handleBack(3)
                                                    }}
                                                    variation="primary rounded">
                                                    {buttonIcon && <ArrowLeftIcon />}
                                                    {t('configure-page:back')}
                                                </Button>
                                                <Button
                                                    variation="secondary rounded"
                                                    onClick={() => {
                                                        handleContinue(3)
                                                    }}>
                                                    {t('configure-page:continue')}
                                                    {buttonIcon && <ArrowRightSpecialsIcon />}
                                                </Button>
                                            </div>
                                        </div>
                                    </Box>
                                </div>
                            </div>
                        )}

                        {step === 4 && (
                            <div className="step-4">
                                {(title5 || subtitle5) && (
                                    <div className="Heading">
                                        {title5 && (
                                            <TitleTag className="Title" dangerouslySetInnerHTML={{ __html: title5 }} />
                                        )}
                                        {subtitle5 && <p className="Subtitle">{subtitle5}</p>}
                                    </div>
                                )}
                                <div className="CalculatorForm">
                                    <div className="col-2">
                                        <Flex
                                            theme={theme}
                                            justifyContent="space-between"
                                            flexDirection={['column', 'column', 'row', 'row']}>
                                            <Box theme={theme} width={['100%', '100%', '31%', '31%']} mb="20px">
                                                <Input
                                                    id="firstName"
                                                    type="text"
                                                    name="firstName"
                                                    label={t('first-name')}
                                                    className={errors.firstName ? 'has-error' : null}
                                                    value={form.firstName}
                                                    onChange={e => setFormValue('firstName', e.target.value)}
                                                />
                                            </Box>

                                            <Box theme={theme} width={['100%', '100%', '31%', '31%']} mb="20px">
                                                <Input
                                                    id="lastName"
                                                    type="text"
                                                    name="lastName"
                                                    label={t('last-name')}
                                                    className={errors.lastName ? 'has-error' : null}
                                                    value={form.lastName}
                                                    onChange={e => setFormValue('lastName', e.target.value)}
                                                />
                                            </Box>

                                            <Box theme={theme} width={['100%', '100%', '31%', '31%']} mb="20px">
                                                <Input
                                                    id="email"
                                                    type="text"
                                                    name="email"
                                                    label={t('email-address')}
                                                    className={errors.email ? 'has-error' : null}
                                                    value={form.email}
                                                    onChange={e => setFormValue('email', e.target.value)}
                                                />
                                            </Box>
                                        </Flex>

                                        <Box theme={theme} mb="20px">
                                            <div className="checkbox-wrapper">
                                                <Checkbox
                                                    id="marketing"
                                                    label={t('configure-page:disclaimer-text')}
                                                    name="marketing"
                                                    onChange={e => setFormValue('marketing', e.target.checked)}
                                                />
                                            </div>
                                        </Box>

                                        <Box theme={theme} mb="20px">
                                            <div className="checkbox-wrapper">
                                                <Checkbox
                                                    id="newsletter"
                                                    label={t('configure-page:newsletter-subscription')}
                                                    name="newsletter"
                                                    onChange={e => setFormValue('newsletter', e.target.checked)}
                                                />
                                            </div>
                                        </Box>

                                        <Box theme={theme} mb="30px">
                                            <div className="CtaContainer">
                                                <div className="CtaContainerInner">
                                                    <Button
                                                        onClick={() => {
                                                            handleBack(4)
                                                        }}
                                                        variation="primary rounded">
                                                        {buttonIcon && <ArrowLeftIcon />}
                                                        {t('configure-page:back')}
                                                    </Button>
                                                    <Button
                                                        variation="secondary rounded"
                                                        disabled={disabledStep4}
                                                        onClick={() => {
                                                            handleSubmit()
                                                        }}>
                                                        {t('configure-page:finish')}
                                                        {buttonIcon && <TickIcon />}
                                                    </Button>
                                                </div>
                                            </div>
                                        </Box>
                                    </div>
                                </div>
                            </div>
                        )}

                        {step === 5 && (
                            <div className="step-5">
                                <div className="ThankYouBlock">
                                    <TickInCircleIcon />
                                    {(title6 || subtitle6) && (
                                        <div className="Heading">
                                            {title6 && (
                                                <TitleTag
                                                    className="Title"
                                                    dangerouslySetInnerHTML={{ __html: title6 }}
                                                />
                                            )}
                                            {subtitle6 && (
                                                // eslint-disable-next-line react/no-danger
                                                <p
                                                    className="Subtitle"
                                                    dangerouslySetInnerHTML={{ __html: t(subtitle6) }}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                                <div className="CtaContainer">
                                    <div className="CtaContainerInner ContinueToHomepage">
                                        <Button variation="secondary rounded" link="/">
                                            {t('configure-page:continue-to-homepage')}
                                            {buttonIcon && <ArrowRightSpecialsIcon />}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </CalculatorBlockStyled>
        )
    }
)

CalculatorBlock.propTypes = {
    title1: PropTypes.string,
    title2: PropTypes.string,
    title3: PropTypes.string,
    title4: PropTypes.string,
    title5: PropTypes.string,
    title6: PropTypes.string,
    subtitle3: PropTypes.string,
    subtitle4: PropTypes.string,
    subtitle5: PropTypes.string,
    subtitle6: PropTypes.string,
    titleTag: PropTypes.string,
    text: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    buttonIcon: PropTypes.bool,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
            text: PropTypes.string
        })
    ),
    offsetFunc: PropTypes.string,
    t: PropTypes.func.isRequired
}

CalculatorBlock.defaultProps = {
    title1: undefined,
    title2: undefined,
    title3: undefined,
    title4: undefined,
    title5: undefined,
    title6: undefined,
    titleTag: 'p',
    text: null,
    subtitle3: null,
    subtitle4: null,
    subtitle5: null,
    subtitle6: null,
    buttonText: null,
    buttonLink: null,
    buttonIcon: null,
    data: [],
    offsetFunc: undefined
}

export default withTheme(CalculatorBlock)
